import { assetDomains } from "rtr-constants";

const ProductImagePathHelpers = {
  isFullPath: path => {
    const domains = Object.values(assetDomains);

    return domains.some(prepend => path.includes(prepend));
  },
};

export default ProductImagePathHelpers;

export const { isFullPath } = ProductImagePathHelpers;
